module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/thread-loader/dist/cjs.js!../../../../../node_modules/babel-loader/lib/index.js?cacheDirectory=true!../../../../../node_modules/ts-loader/index.js??ref--5-2!./advance-directives.ts"));
	}, "advance-directives");
}